import * as actionTypes from '../actions/types';

export const setWindowSize = (width) => ({
  type: actionTypes.SET_WINDOW_SIZE,
  width
});